<template>
  <div id="SupplierOwnEdit">
    <el-dialog :title="title" width="540px" :visible.sync="isVisibleTemp" @close="closeAndclear('mySupplierInfo')">
      <el-form :model="mySupplierInfo" :rules="rules" ref="mySupplierInfo">
        <el-form-item label="供应商名称" :label-width="formLabelWidth">
          <el-input v-model="mySupplierInfo.departName" auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="供应商编码" :label-width="formLabelWidth" prop="supplierCode">
          <el-input class="eb-input panel-body-row-right" v-model="mySupplierInfo.supplierCode" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="供应商级别" :label-width="formLabelWidth" prop="companyLevel">
          <el-select v-model="mySupplierInfo.companyLevel" clearable placeholder="请选择供应商级别">
            <el-option label="战略" value="0"></el-option>
            <el-option label="优选" value="1"></el-option>
            <el-option label="普通" value="2"></el-option>
            <el-option label="拉黑" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="采购方批注" :label-width="formLabelWidth">
          <el-input type="textarea" class="eb-textarea" :rows="4" v-model="mySupplierInfo.purchaseLabel" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="closeAndclear('mySupplierInfo')">取消</el-button>
        <el-button v-if="mySupplierInfo.operType === 'add'" class="eb-button-group-btn eb-button-orange eb-button-big" @click="addSupplier">确定</el-button>
        <el-button v-else class="eb-button-group-btn eb-button-orange eb-button-big" @click="editSupplier">确定</el-button>
      </div>

    </el-dialog>
  </div>
</template>
<script>
import { addSupplier, editSupplier } from '@/services/user/user-supplier-service';
export default {
  props: {
    mySupplierInfo: {
      type: Object
    },
    isVisible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    var validateLevel = (rule, value, callback) => {
      if (!value || value === '4') {
        callback(new Error('请选择供应商级别'));
      } else {
        callback();
      }
    };
    return {
      formLabelWidth: '120px',
      rules: {
        supplierCode: [{ required: true, message: '请输入供应商编码', trigger: 'blur' }],
        companyLevel: [{ validator: validateLevel, required: true, trigger: 'blur' }]
      }
    };
  },
  computed: {
    title() {
      if (this.mySupplierInfo.operType === 'add') {
        return '添加为我的供应商';
      } else {
        return '修改我的供应商';
      }
    },
    isVisibleTemp: {
      get: function() {
        return this.isVisible;
      },
      set: function(val) {
        this.$emit('update:isVisible', val);
      }
    }
  },
  methods: {
    // 保存为我的供应商
    addSupplier() {
      this.$refs['mySupplierInfo'].validate(async valid => {
        if (valid) {
          this.$root.layout.isLoading = true;
          this.mySupplierInfo.supplierId = this.mySupplierInfo.departId;
          try {
            let { data } = await addSupplier(this.mySupplierInfo);
            if (data.returnCode === '04') {
              this.$message.error('供应商编码重复');
              this.$root.layout.isLoading = false;
              return;
            } else if (data.returnCode === '01') {
              this.isVisibleTemp = false;
              this.$message.success('添加成功');
              this.$emit('addSupplierSuccess');
            } else if (data.returnCode === '00') {
            } else {
              this.$message.error('添加失败');
            }
          } catch (error) {
            this.$message.error(error.message);
          }
          this.$root.layout.isLoading = false;
        } else {
          console.log('error submit!!');
        }
      });
    },
    editSupplier() {
      this.buttonLoading = true;
      this.$refs['mySupplierInfo'].validate(async valid => {
        if (valid) {
          this.$root.layout.isLoading = true;
          this.mySupplierInfo.supplierId = this.mySupplierInfo.departId;
          this.mySupplierInfo.userSupplierId = this.mySupplierInfo.userSupplierId;
          this.mySupplierInfo.buyerId = this.mySupplierInfo.buyerId;
          try {
            let { data } = await editSupplier(this.mySupplierInfo);
            if (data.returnCode === '04') {
              this.$message.error('供应商编码重复');
              this.$root.layout.isLoading = false;
              return;
            } else if (data.returnCode === '01') {
              this.isVisibleTemp = false;
              this.$message.success('修改成功');
              this.$emit('addSupplierSuccess');
            } else if (data.returnCode === '00') {
            } else {
              this.$message.error('修改失败');
            }
          } catch (error) {
            this.$message.error(error.message);
          }
          this.$root.layout.isLoading = false;
        } else {
          console.log('error submit!!');
        }
      });
    },
    closeAndclear(mySupplierInfo) {
      this.isVisibleTemp = false;
      this.$refs[mySupplierInfo].resetFields();
    }
  }
};
</script>
